import React, { useMemo, useState, useEffect } from "react";
import {
  Card,
  Form,
  Button,
  Row,
  Col,
  Table,
  Modal,
} from "react-bootstrap";
import Layout from "../../layout/Layout";
import "../../styles/StandardDocument.css";
import { TrainingEnum } from "../../common/trainingTypes";
import { createDocumentHandleChange } from "../../helper/createDocumentHandleChange";

import { getInsanKaynaklariPersonelList } from "../../../api/DocumentApi/humanResourcesApi";

function IKPersonelList() {
  // ------------------- STATE & AUTH -------------------

  const [filters, setFilters] = useState({
    search: "",
    cinsiyet: "",
    isActive: "",
    gorev: "",
    egitimDurumu: "",
    riskSinifi: "",
  });
  console.log(filters, "12121121");

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingDoc, setEditingDoc] = useState(null);

  const [feedback, setFeedback] = useState({
    show: false,
    type: "success",
    message: "",
  });

  const [newDoc, setNewDoc] = useState({
    calismaDurumu: "",
    ad: "",
    soyad: "",
    tcNo: "",
    cinsiyet: "",
    dogumTarihi: "",
    iseGirisTarihi: "",
    yas: "",
    file: null,
    yasAraligi: "",
    firmaTehlikeSinifi: "",
    egitimDurumu: "",
    gorev: "",
    isGuvenligiEgitim: "",
    kkdZimmet: "",
    reminderActive: false,
    startDate: "",
    endDate: "",
    note: "",
    notifyBefore: "",
    trainings: [],
  });

  const [docs, setDocs] = useState([]);
  console.log(docs, "2222222");

  // ------------------- DEFAULT TRAININGS -------------------
  const defaultTrainings = useMemo(
    () =>
      Object.keys(TrainingEnum).map((key) => ({
        trainingName: key,
      })),
    []
  );

  // ------------------- FETCH DATA -------------------
  useEffect(() => {
    const fetchDocs = async () => {
      try {
        const res = await getInsanKaynaklariPersonelList();
        if (res.data.statusCode === 200) {
          setDocs(res.data.data);
        }
      } catch (err) {
        console.error("Belgeler çekilemedi:", err);
      }
    };
    fetchDocs();
  }, []);

  // ------------------- FILTERING -------------------
  const filteredDocs = docs.filter((d) => {
    const searchMatch = `${d.firstName} ${d.lastName}`
      .toLowerCase()
      .includes(filters.search.toLowerCase());

    const genderMatch = !filters.cinsiyet
      ? true
      : d.gender?.toUpperCase() === filters.cinsiyet;

    const activeMatch = !filters.isActive
      ? true
      : d.isActive === (filters.isActive === "true");

    const gorevMatch = !filters.gorev ? true : d.position === filters.gorev;

    const egitimMatch = !filters.egitimDurumu
      ? true
      : d.educationLevel === filters.egitimDurumu;

    return (
      searchMatch && genderMatch && activeMatch && gorevMatch && egitimMatch
    );
  });

  // ------------------- SORTING -------------------
  const sortedDocs = [...filteredDocs].sort((a, b) => {
    return new Date(b.hireDate) - new Date(a.hireDate);
  });

  // ------------------- MODAL CONTROL -------------------
  const handleShow = () => setShowModal(true);

  const handleClose = () => {
    setShowModal(false);
    setNewDoc({
      calismaDurumu: "",
      ad: "",
      soyad: "",
      tcNo: "",
      cinsiyet: "",
      dogumTarihi: "",
      iseGirisTarihi: "",
      firmaTehlikeSinifi: "",
      egitimDurumu: "",
      gorev: "",
      trainings: [],
    });
  };

 

  const handleCloseEdit = () => {
    setShowEditModal(false);
    setEditingDoc(null);
    setNewDoc({
      calismaDurumu: "",
      ad: "",
      soyad: "",
      tcNo: "",
      cinsiyet: "",
      dogumTarihi: "",
      iseGirisTarihi: "",
      firmaTehlikeSinifi: "",
      egitimDurumu: "",
      gorev: "",
      trainings: [],
    });
  };

  // ------------------- INPUT CHANGE -------------------
const handleChange = createDocumentHandleChange({
  setNewDoc,
  getIsEditMode: () => Boolean(editingDoc?._id),
});

  //  Eğitim Alanı Güncelleme
  const handleTrainingChange = (e, index) => {
    const { name, value } = e.target;
    setNewDoc((prev) => {
      const updatedTrainings = [...(prev.trainings || [])];
      updatedTrainings[index] = { ...updatedTrainings[index], [name]: value };
      return { ...prev, trainings: updatedTrainings };
    });
  };
  // Yeni eğitim ekleme
  const handleAddTraining = () => {
    setNewDoc((prev) => ({
      ...prev,
      trainings: [
        ...(prev.trainings || []),
        {
          trainingName: "",
          required: false,
          examStatus: "None",
          topics: "",
          certificateStartDate: "",
          certificateExpiryDate: "",
          certificateReceived: false,
          certificateNotReceived: false,
        },
      ],
    }));
  };

  // Eğitim silme
  const handleRemoveTraining = (index) => {
    setNewDoc((prev) => ({
      ...prev,
      trainings: prev.trainings.filter((_, i) => i !== index),
    }));
  };

  // ------------------- DEFAULT TRAINING FILLER -------------------
  useEffect(() => {
    if (showEditModal && editingDoc && !editingDoc.trainings?.length) {
      setNewDoc((prev) => ({
        ...prev,
        trainings: defaultTrainings,
      }));
    }
  }, [showEditModal, editingDoc, defaultTrainings]);

  return (
    <Layout>
      <h2 className="fw-bold mb-4">Personel Listesi</h2>
      <Card className="border-0 bg-transparent mb-3">
        <div
          className="d-flex justify-content-end align-items-center"
          style={{ minHeight: "40px" }}
        >
          <Button variant="primary" size="sm" onClick={handleShow}>
            + Yeni Ekle
          </Button>
        </div>
      </Card>
      <Card className="p-3 mb-4 shadow-sm border-0">
        <Row className="align-items-center g-3">
          {/* 🔍 Arama */}
          <Col md={3}>
            <Form.Control
              type="text"
              placeholder="Ad veya Soyad ile ara..."
              value={filters.search}
              onChange={(e) =>
                setFilters({ ...filters, search: e.target.value })
              }
            />
          </Col>

          {/* 👤 Cinsiyet */}
          <Col md={2}>
            <Form.Select
              value={filters.cinsiyet}
              onChange={(e) =>
                setFilters({ ...filters, cinsiyet: e.target.value })
              }
            >
              <option value="">Cinsiyet (Hepsi)</option>
              <option value="ERKEK">Erkek</option>
              <option value="KADIN">Kadın</option>
            </Form.Select>
          </Col>

          {/* 🏢 Çalışma Durumu */}
          <Col md={2}>
            <Form.Select
              value={filters.isActive}
              onChange={(e) =>
                setFilters({ ...filters, isActive: e.target.value })
              }
            >
              <option value="">Durum (Hepsi)</option>
              <option value="true">Aktif</option>
              <option value="false">Pasif</option>
            </Form.Select>
          </Col>

          {/* 🧰 Görev */}
          <Col md={2}>
            <Form.Select
              value={filters.gorev}
              onChange={(e) =>
                setFilters({ ...filters, gorev: e.target.value })
              }
            >
              <option value="">Görev (Hepsi)</option>
              {[...new Set(docs.map((d) => d.position).filter(Boolean))].map(
                (pos, i) => (
                  <option key={i} value={pos}>
                    {pos}
                  </option>
                )
              )}
            </Form.Select>
          </Col>

          {/* 🎓 Eğitim Durumu */}
          <Col md={2}>
            <Form.Select
              value={filters.egitimDurumu}
              onChange={(e) =>
                setFilters({ ...filters, egitimDurumu: e.target.value })
              }
            >
              <option value="">Eğitim Durumu (Hepsi)</option>
              {[
                ...new Set(docs.map((d) => d.educationLevel).filter(Boolean)),
              ].map((edu, i) => (
                <option key={i} value={edu}>
                  {edu}
                </option>
              ))}
            </Form.Select>
          </Col>

          {/* 🧹 Temizle */}
          <Col md="auto">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() =>
                setFilters({
                  search: "",
                  cinsiyet: "",
                  isActive: "",
                  calismaDurumu: "",
                  gorev: "",
                  egitimDurumu: "",
                  riskSinifi: "",
                })
              }
            >
              Temizle
            </Button>
          </Col>
        </Row>
      </Card>

      <Card className="shadow-sm border-0">
        <Table hover responsive className="mb-0 align-middle">
          <thead className="table-light">
            <tr>
              <th>Ad Soyad</th>
              <th>TC No</th>
              <th>Cinsiyet</th>
              <th>Çalışma Durumu</th>
              <th>Görev</th>
              <th>Eğitim Durumu</th>
              <th>Firma Tehlike Sınıfı</th>
              <th>İşe Alınma Tarihi</th>
            </tr>
          </thead>

          <tbody>
            {sortedDocs.length > 0 ? (
              sortedDocs.map((d) => (
                <React.Fragment key={d._id}>
                  <tr>
                    <td>{`${d.firstName || ""} ${d.lastName || ""}`}</td>
                    <td>{d.nationalId || "-"}</td>
                    <td>{d.gender || "-"}</td>
                    <td>
                      {d.isActive ? (
                        <span className="badge bg-success">Aktif</span>
                      ) : (
                        <span className="badge bg-secondary">Pasif</span>
                      )}
                    </td>
                    <td>{d.position || "-"}</td>
                    <td>{d.educationLevel || "-"}</td>
                    <td>{d.companyRiskClass || "-"}</td>
                    <td>{d.hireDate || "-"}</td>
                  </tr>
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="12" className="text-center py-4 text-muted">
                  Kayıt bulunamadı
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>

      <Modal
        show={showModal}
        onHide={handleClose}
        centered
        size="xl"
        fullscreen="md-down"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Yeni İSG Personeli Ekle</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "2rem" }}>
          <Form>
            <Row className="gy-4 gx-5">
              {/* SOL TARAF - PERSONEL BİLGİLERİ */}
              <Col md={4} className="border-end pe-4">
                <h5 className="mb-3">Personel Bilgileri</h5>
                <Row className="g-3">
                  {[
                    ["Ad", "ad"],
                    ["Soyad", "soyad"],
                    ["TC No", "tcNo"],
                    ["Cinsiyet", "cinsiyet"],
                    ["Çalışma Durumu", "calismaDurumu"],
                    ["Firma Tehlike Sınıfı", "firmaTehlikeSinifi"],
                    ["Eğitim Durumu", "egitimDurumu"],
                    ["Görev", "gorev"],
                    ["İşe Giriş Tarihi", "iseGirisTarihi", "date"],
                    ["KKD Zimmet", "kkdZimmet", "date"],
                  ].map(([label, name, type = "text"], i) => (
                    <Col xs={12} key={i}>
                      <Form.Group>
                        <Form.Label>{label}</Form.Label>
                        {name === "cinsiyet" ? (
                          <Form.Select
                            name={name}
                            value={newDoc[name] || ""}
                            onChange={handleChange}
                          >
                            <option value="">Seçiniz</option>
                            <option value="ERKEK">Erkek</option>
                            <option value="KADIN">Kadın</option>
                          </Form.Select>
                        ) : name === "calismaDurumu" ? (
                          <Form.Select
                            name={name}
                            value={newDoc[name] || ""}
                            onChange={handleChange}
                          >
                            <option value="AKTİF">AKTİF</option>
                            <option value="PASİF">PASİF</option>
                          </Form.Select>
                        ) : name === "firmaTehlikeSinifi" ? (
                          <Form.Select
                            name={name}
                            value={newDoc[name] || ""}
                            onChange={handleChange}
                          >
                            <option value="">Seçiniz</option>
                            <option value="AZ TEHLİKELİ">AZ TEHLİKELİ</option>
                            <option value="ÇOK TEHLİKELİ">ÇOK TEHLİKELİ</option>
                          </Form.Select>
                        ) : name === "egitimDurumu" ? (
                          <Form.Select
                            name={name}
                            value={newDoc[name] || ""}
                            onChange={handleChange}
                          >
                            <option value="">Seçiniz</option>
                            <option value="LİSANS">LİSANS</option>
                            <option value="ÖNLİSANS">ÖNLİSANS</option>
                            <option value="LİSE">LİSE</option>
                            <option value="ORTAOKUL">ORTAOKUL</option>
                            <option value="İLKOKUL">İLKOKUL</option>
                          </Form.Select>
                        ) : (
                          <Form.Control
                            type={type}
                            name={name}
                            value={newDoc[name] || ""}
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            İptal
          </Button>
          <Button variant="primary">Kaydet</Button>
        </Modal.Footer>
      </Modal>

      {/* Düzenleme Modalı */}
      <Modal
        show={showEditModal}
        onHide={handleCloseEdit}
        centered
        size="xl"
        fullscreen="md-down"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Personel Bilgilerini Düzenle</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "2rem" }}>
          <Form>
            <Row className="gy-4 gx-5">
              {/* SOL TARAF */}
              <Col md={4} className="border-end pe-4">
                <h5 className="mb-3">Personel Bilgileri</h5>
                <Row className="g-3">
                  {[
                    ["Ad", "firstName"],
                    ["Soyad", "lastName"],
                    ["TC No", "nationalId"],
                    ["Cinsiyet", "gender"],
                    ["Çalışma Durumu", "employmentStatus"],
                    ["Firma Tehlike Sınıfı", "companyRiskClass"],
                    ["Eğitim Durumu", "educationLevel"],
                    ["Görev", "position"],
                    ["İşe Giriş Tarihi", "hireDate", "date"],
                    ["KKD Zimmet", "ppeAssignmentDate", "date"],
                  ].map(([label, name, type = "text"], i) => (
                    <Col xs={12} key={i}>
                      <Form.Group>
                        <Form.Label>{label}</Form.Label>
                        {name === "gender" ? (
                          <Form.Select
                            name={name}
                            value={newDoc[name] || ""}
                            onChange={handleChange}
                          >
                            <option value="">Seçiniz</option>
                            <option value="ERKEK">Erkek</option>
                            <option value="KADIN">Kadın</option>
                          </Form.Select>
                        ) : name === "employmentStatus" ? (
                          <Form.Select
                            name={name}
                            value={newDoc[name] || ""}
                            onChange={handleChange}
                          >
                            <option value="AKTİF">AKTİF</option>
                            <option value="PASİF">PASİF</option>
                          </Form.Select>
                        ) : (
                          <Form.Control
                            type={type}
                            name={name}
                            value={newDoc[name] || ""}
                            onChange={handleChange}
                          />
                        )}
                      </Form.Group>
                    </Col>
                  ))}
                </Row>
              </Col>

              {/* SAĞ TARAF */}
              <Col md={8} className="ps-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h5 className="mb-0">Eğitim Bilgileri</h5>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={handleAddTraining}
                  >
                    + Yeni Eğitim
                  </Button>
                </div>

                <div className="d-flex flex-column gap-4">
                  {(newDoc.trainings || []).map((training, index) => (
                    <div
                      key={index}
                      className="border rounded-4 p-4 shadow-sm bg-light d-flex flex-wrap align-items-center justify-content-between gap-3"
                    >
                      {/* Eğitim Adı */}
                      <div className="flex-grow-1">
                        <strong className="d-block mb-2">
                          {TrainingEnum[training.trainingName] ||
                            training.trainingName}
                        </strong>
                        <div className="d-flex flex-wrap gap-3 align-items-center">
                          <Form.Check
                            type="checkbox"
                            label="Alması Gerek"
                            checked={training.required || false}
                            onChange={(e) =>
                              handleTrainingChange(
                                {
                                  target: {
                                    name: "required",
                                    value: e.target.checked,
                                  },
                                },
                                index
                              )
                            }
                          />

                          <Form.Control
                            type="date"
                            name="certificateStartDate"
                            value={training.certificateStartDate || ""}
                            onChange={(e) => handleTrainingChange(e, index)}
                            style={{ width: "170px" }}
                          />

                          <Form.Control
                            type="date"
                            name="certificateExpiryDate"
                            value={training.certificateExpiryDate || ""}
                            onChange={(e) => handleTrainingChange(e, index)}
                            style={{ width: "170px" }}
                          />

                          <Form.Select
                            name="examStatus"
                            value={training.examStatus || "None"}
                            onChange={(e) => handleTrainingChange(e, index)}
                            style={{ width: "150px" }}
                          >
                            <option value="None">Yok</option>
                            <option value="Pending">Beklemede</option>
                            <option value="Passed">Geçti</option>
                            <option value="Failed">Kaldı</option>
                          </Form.Select>

                          <Form.Check
                            type="checkbox"
                            label="Sertifika"
                            checked={training.certificateReceived || false}
                            onChange={(e) =>
                              handleTrainingChange(
                                {
                                  target: {
                                    name: "certificateReceived",
                                    value: e.target.checked,
                                  },
                                },
                                index
                              )
                            }
                          />
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleRemoveTraining(index)}
                          >
                            × Kaldır
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEdit}>
            İptal
          </Button>
          <Button variant="primary">Güncelle</Button>
        </Modal.Footer>
      </Modal>

      {/* Feedback Modal */}
      <Modal
        show={feedback.show}
        onHide={() => setFeedback({ ...feedback, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {feedback.type === "success" ? "Başarılı" : "Hata"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{feedback.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setFeedback({ ...feedback, show: false })}
          >
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}

export default IKPersonelList;
